export default __webpack_public_path__ + "static/media/pantry2-before2-1024w.be902f6e.avif";